// extracted by mini-css-extract-plugin
module.exports = {"sectionBrand":"Brand_sectionBrand__2G2NJ","brand":"Brand_brand__26xsT","brandPage":"Brand_brandPage__2Z9pn","principalBrand":"Brand_principalBrand__2h_iG"};